import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {Button, Card, Form} from 'antd';
import Call from '../../../../../hocs/call';
import {GUTTER_MD, PADDING_SM} from '../../../../../styles/constants';
import {
    addAliasColsDatasetBuilder, datasetBuilderGetTableViewColumnsForModal,
} from "../actions";
import UnionColumnComponentList from "./UnionColumnComponentList";
import {isForcedChecked} from "./utils";

const mapStateToProps = state => {
    const {currentlySelectedTable} = state.scenes.mappingHandler.datasetBuilder.unionModalProps;
    return {
        connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
        aliasCols: state.scenes.mappingHandler.datasetBuilder.unionModalProps.aliasCols,
        tableViewColumns: state.scenes.mappingHandler.datasetBuilder.unionModalProps.tableViewColumns,
        currentlySelectedTable: state.scenes.mappingHandler.datasetBuilder.unionModalProps.currentlySelectedTable,
        tableViewId: currentlySelectedTable && currentlySelectedTable.tableViewId ? currentlySelectedTable.tableViewId : null,
    }
};

const mapDispatchToProps = dispatch => ({
    addAliasCols: (cols) => dispatch(addAliasColsDatasetBuilder(cols)),
    fetchTableViewColumns: ({
                                connId,
                                tableViewId
                            }) => dispatch(datasetBuilderGetTableViewColumnsForModal(connId, tableViewId))
});

const mapPropsToFields = ({
                              tableViewColumns
                          }) => ({
    columns: Form.createFormField({value: tableViewColumns ? tableViewColumns : null})
});

const QueryColumnsForm = ({
                              t,
                              form,
                              tableViewId,
                              fetchTableViewColumns,
                              addAliasCols,
                              aliasCols,
                              connId
                          }) => {
    return (
        <Form style={{
            display: 'flex',
            height: "100%",
            width: "100%"
        }
        }>
            <Call cb={fetchTableViewColumns} cbParam={{connId, tableViewId}} disabled={!tableViewId === null}>
                {(!!tableViewId) && (
                    <Fragment>
                        <div style={{display: "flex", flexDirection: "row", gap: GUTTER_MD, width: "100%"}}>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                height: "100%",
                                width: "100%"
                            }}>
                                <Card
                                    style={{width: "100%"}}
                                    bodyStyle={{
                                        height: "100%",
                                        overflow: 'auto',
                                        // 200px valid until the modal is kept fullscreen
                                        maxHeight: "calc(100vh - 200px)"
                                    }}
                                >
                                    {form.getFieldDecorator('columns')(
                                        <UnionColumnComponentList/>
                                    )}
                                </Card>
                            </div>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: PADDING_SM
                            }}>
                                <Button
                                    size="small"
                                    icon="block"
                                    title={t("commons.buttons.selectAll.title")}
                                    disabled={form.getFieldValue("columns") ? form.getFieldValue("columns").dimensions.every(col => col.checked || col.disabled || isForcedChecked(aliasCols, col.Code)) : false}
                                    onClick={() => {
                                        const cols = form.getFieldValue("columns");
                                        form.setFieldsValue({
                                            columns: {
                                                dimensions: cols.dimensions.map(col => ({
                                                    ...col,
                                                    checked: true
                                                }))
                                            }
                                        })
                                    }}
                                />
                                <Button
                                    size="small"
                                    icon="double-right"
                                    type="primary"

                                    title={t("scenes.mappingHandler.DatasetBuilder.wizard.step.query.addToUnion")}
                                    onClick={() => {
                                        const cols = form.getFieldValue("columns");
                                        const finalCols = []
                                        Object.values(cols).forEach(dimArray => {
                                            dimArray.forEach(dim => {
                                                if (!dim.disabled && dim.checked) {
                                                    finalCols.push({colID: dim.Code, colValue: "", props: dim});
                                                }
                                            })
                                        })
                                        addAliasCols(finalCols.filter(item => !aliasCols.filter(col => !col.fixedValue).map(col => col.colID).includes(item.colID)));
                                    }}
                                />
                            </div>
                        </div>
                    </Fragment>
                )}
            </Call>
        </Form>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({
        mapPropsToFields,
    })
)(QueryColumnsForm);
